import React from "react";
import { Route, Switch } from "react-router-dom";

import NotFound from "../pages/user/NotFound";
import News from "../pages/user/News";
import ProFileDetail from "../pages/user/ProFile/Detail";
import ProFileList from "../pages/user/ProFile/ProFileList";
import FormPhone from "../pages/user/ProFile/FormPhone";
import ProFilePersonalStatus from "../pages/user/ProFile/PersonalStatus";
import ProFilePersonalInformation from "../pages/user/ProFile/PersonalInformation";
import ProFileAddress from "../pages/user/EmpRegistration/Address";
import EmpRegistrationPayment from "../pages/user/EmpRegistration/Payment";
import EmpRegistrationTax from "../pages/user/EmpRegistration/Tax";
import EmpRegistrationRights from "../pages/user/EmpRegistration/Rights";
import Attendace from "../pages/user/Attendance";
import Slip from "../pages/user/Slip";
import DetailNews from "../pages/user/DetailNews";
import Contact from "../pages/user/Contact";
import ContactDepartment from "../pages/user/ContactDepartment";
import ContactDetail from "../pages/user/ContactDetail";
import Abouts from "../pages/user/Abouts";
import AboutsLink from "../pages/user/AboutsLink";
import AboutsLinkDetail from "../pages/user/AboutsLinkDetail";
import ContactHR from "../pages/user/ContactHR";
import Course from "../pages/user/Course";
import CourseDetail from "../pages/user/CourseDetail";
import CourseDetailConicle from "../pages/user/CourseDetail/conicle";
import LayoutsNoData from "../pages/user/LayoutsNoData";
import ChangePassword from "../pages/user/ChangePassword";
import Notification from "../pages/user/Notification";
import Policy from "../pages/user/Policy";
import PolicyDetail from "../pages/user/PolicyDetail";
import Orientation from "../pages/user/Orientation";
import OrientationDetail from "../pages/user/OrientationDetail";
import PolicyOfficerDocuments from "../pages/user/PolicyOfficerDocuments";
import PolicyQualityDocument from "../pages/user/PolicyQualityDocument";
import HospitalSearchForm from "../pages/user/Hospital/Search";
import HospitalForm from "../pages/user/Hospital/Form";
import HospitalWithdraw from "../pages/user/Hospital/Withdraw";
import HospitalWithdrawDetail from "../pages/user/Hospital/Withdraw/detail";
import HospitalDashBoardConfirm from "../pages/user/Hospital/DashBoardConfirm";
import HospitalFormConfirm from "../pages/user/Hospital/Confirm/detail";
import HospitalDashBoardStatus from "../pages/user/Hospital/DashBoardStatus";
import HospitalCreate from "../pages/user/Hospital/CreateHospital";
import HospitalConfirm from "../pages/user/Hospital/Confirm";
import HospitalNews from "../pages/user/Hospital/News";

import LeaveStudiesDashboard from "../pages/user/LeaveStudies/Dashboard";
import LeaveStudiesForm from "../pages/user/LeaveStudies/Form";

import ChildEducationFee from "../pages/user/ChildEducationFee/";
import ChildEducationFeeDetail from "../pages/user/ChildEducationFee/detail";

import AbstainTimeForm from "../pages/user/AbstainTime/createUpdate";
import AbstainTimeDashboardApproves from "../pages/user/AbstainTime/approves";
import AbstainTimeFormApproves from "../pages/user/AbstainTime/approves/detail";
import AbstainTimeDashboard from "../pages/user/AbstainTime/dashboard";

import AlwaysUpcoming from "../pages/user/AlwaysUpcoming/";

import LeaveSearchForm from "../pages/user/Leave/Search";
import LeaveForm from "../pages/user/Leave/Form";
import LeaveFormDetail from "../pages/user/Leave/Form/detail";
import LeaveFormDetailDarf from "../pages/user/Leave/Form/detailDarf";
import LeaveConfirm from "../pages/user/Leave/Confirm";
import LeaveConfirmDetail from "../pages/user/Leave/Confirm/detail";
import LeaveConfirmNotification from "../pages/user/Leave/Confirm/notification";
import LeaveCancelDetail from "../pages/user/Leave/Cancel/detail";
import LeaveCancel from "../pages/user/Leave/Cancel";

import ListForManager from "../pages/user/Leave/ListForManager";
import LeaveManual from "../pages/user/Leave/Manual";
import MeetingManagement from "../pages/user/MeetingManagement/CalendarMeeting";
import CalendarForm from "../pages/user/MeetingManagement/CalendarMeeting/CalendarForm.js";
import CreateMeeting from "../pages/user/MeetingManagement/Manage/CreateMeeting.js";
import CreateMeetingForm from "../pages/user/MeetingManagement/Manage/CreateMeetingForm.js";
import CreateMeetingFormWithApprove from "../pages/user/MeetingManagement/Manage/CreateMeetingFormWithApprove.js";
import ViewMeetingForm from "../pages/user/MeetingManagement/ViewMeeting/ViewMeetingForm.js";

import WaitMeeting from "../pages/user/MeetingManagement/Wait/WaitMeeting.js";
import WaitMeetingForm from "../pages/user/MeetingManagement/Wait/WaitMeetingForm.js";
import WaitMeetingFormEdit from "../pages/user/MeetingManagement/Wait/WaitMeetingFormEdit.js";

import SentNoteMeetingForm from "../pages/user/MeetingManagement/SentNoteMeeting/SentNoteMeetingForm";

import WaitApproveList from "../pages/user/MeetingManagement/WaitApprove/WaitApproveList";
import ApproveMeetingForm from "../pages/user/MeetingManagement/WaitApprove/ApproveMeetingForm";

import InviteMeeting from "../pages/user/MeetingManagement/JoinMeeting/InviteMeeting";
import InviteMeetingForm from "../pages/user/MeetingManagement/JoinMeeting/InviteMeetingForm";

import NoteMeeting from "../pages/user/MeetingManagement/NoteMeeting/NoteMeeting";
import NoteMeetingForm from "../pages/user/MeetingManagement/NoteMeeting/NoteMeetingForm";

import CreatePDFMeeting from "../pages/user/MeetingManagement/ViewMeeting/CreatePDFMeeting";

// import ViewMeetingFormWithApprove from '../pages/user/MeetingManagement/ViewMeeting/ViewMeetingFormWithApprove.js'

import { Queries } from "../graphql";
import { createApolloFetch } from "apollo-fetch";
import { createUploadLink } from "apollo-upload-client";
import { apiKeyNews } from "../utils/apiKey";
import { setToken, getToken, clearAllStorage } from "../utils/auth";
import workHistory from "../pages/user/workHistory";
import Delegate from "../pages/user/Delegate";

import Fund from "../pages/user/Fund/DetailFund";
import FundBenefitsPerson from "../pages/user/Fund/DetailFund/benefitsPerson";
import FundNews from "../pages/user/Fund/News";

//WelfareList
import WelfareList from "../pages/user/WelfareList/dashboard";
import WelfareListPaymentVictim from "../pages/user/WelfareList/paymentVictim/form";
import WelfareListStudyPayment from "../pages/user/WelfareList/studyPayment/form";
import WelfareListDashboardApproves from "../pages/user/WelfareList/dashboard/approve";
import WelfareListOtherWelfare from "../pages/user/WelfareList/otherWelfare/form";
import SecuritySettings from "../pages/user/ProFile/SecuritySettings";


export const initialKey = "news";

/* Struct {
	key: String, 'unique key',
	label!: String 'display name on menu',
	icon!: String 'AntD icon',
	path!: String 'path for routing',
	isShow!: Boolean 'if it is true display on menu',
	component: React Node 'component to render',
	children?: Array 'sub route for routing'
} */

const checkLinkURL = () => {
  if (window.location.href.includes("https://vtrc.redcross.or.th/")) {
    return "https://vtrcapi.redcross.or.th/api/graphql";
    // return "https://vtrcapi.redcross.or.th/backup-site/graphql"
    // return "https://uat-vtrcapi.redcross.or.th/api-uat/graphql"
  } else if (
    window.location.href.includes("https://uat-vtrc.redcross.or.th/")
  ) {
    // return "https://vtrcapi.redcross.or.th/api/graphql"
    // return "https://vtrcapi.redcross.or.th/backup-site/graphql"
    return "https://uat-vtrcapi.redcross.or.th/api-uat/graphql";
  } else if (
    window.location.href.includes("http://localhost:3000/") ||
    window.location.href.includes("http://192.168.0.105:3000/")
  ) {
    // return "http://192.168.0.162:8081/api/graphql"
    // return "https://vtrcapi.redcross.or.th/api/graphql"
    // return "https://vtrcapi.redcross.or.th/backup-site/graphql"
    return "https://uat-vtrcapi.redcross.or.th/api-uat/graphql";
  }
};

const apolloFetch = createApolloFetch({ uri: checkLinkURL() });

const fetchListmenu = async () => {
  // const { errors, data } = await apolloFetch({
  // 	query: Queries.refreshToken,
  // 	variables: {
  // 		refreshToken: getToken().refreshToken,
  // 		token: getToken().token
  // 	},
  // })
  return "test";
};

export const routes = [
  {
    key: "notification",
    label: "แจ้งเตือน",
    icon: "bell",
    path: "/notification",
    isShow: true,
    component: Notification,
    children: [
      {
        path: "/:courseId",
        component: Notification,
      },
    ],
  },
  {
    key: "news",
    label: "ข่าวสาร",
    icon: "appstore",
    path: "/news",
    isShow: true,
    component: News,
    children: [
      {
        key: "DetailNews",
        icon: "",
        path: "/detailnews",
        isShow: false,
        children: [
          {
            path: "/:newId",
            component: DetailNews,
          },
        ],
      },
    ],
  },
  {
    key: "hospital",
    label: "การเบิกค่ารักษาพยาบาล",
    icon: "appstore",
    path: "/hospital",
    isShow: true,
    children: [
      {
        label: "รายการเบิกทั้งหมด",
        path: "/search",
        component: HospitalSearchForm,
        isShow: true,
      },
      {
        label: "ผู้มีสิทธิเบิกค่ารักษาพยาบาล",
        path: "/create",
        component: HospitalForm,
        isShow: true,
      },
      {
        label: "เพิ่มขอเบิก",
        path: "/Withdraw",
        component: HospitalWithdraw,
        isShow: false,
        children: [
          {
            path: "/:postId",
            component: HospitalWithdrawDetail,
          },
        ],
      },
      {
        label: "รายการอนุมัติ",
        path: "/Confirm",
        key: "hospitalConfirm",
        component: HospitalConfirm,
        isShow: true,
        isShowSubmenuDynamic: [1],
        children: [
          {
            path: "/:postId/:status",
            component: HospitalFormConfirm,
          },
        ],
      },
      {
        label: "ข่าวสารการเบิกค่ารักษาพยาบาล",
        icon: "",
        path: "/News",
        isShow: true,
        component: HospitalNews,
      },
      {
        path: "/detailnews/:newId",
        component: DetailNews,
      },
    ],
  },
//   {
//     key: "leaveStudies",
//     label: "การศึกษา/ฝึกอบรมเฉพาะทาง",
//     icon: "appstore",
//     path: "/LeaveStudies",
//     isShow: true,
//     children: [
//       {
//         label: "รายการการศึกษา/ฝึกอบรมเฉพาะทาง",
//         path: "/Dashboard",
//         component: LeaveStudiesDashboard,
//         isShow: true,
//       },
//       {
//         label: "เพิ่มคำขอลา",
//         path: "/day",
//         // component: LeaveForm,
//         isShow: false,
//         children: [
//           {
//             path: "/edit/:postId",
//             component: LeaveStudiesForm,
//           },
//           // {
//           // 	path: '/darf/:postId',
//           // 	component: LeaveFormDetailDarf
//           // },
//         ],
//       },
//     ],
//   },
  // {
  //   key: "AbstainTime",
  //   label: "แก้ไขการลงเวลาทำงาน",
  //   icon: "appstore",
  //   path: "/AbstainTime",
  //   isShow: true,
  //   children: [
  //     {
  //       label: "รายการแก้ไขการลงเวลาทำงาน",
  //       path: "/Dashboard",
  //       component: AbstainTimeDashboard,
  //       isShow: true,
  //     },
  //     {
  //       label: "สร้างเอกสารแก้ไขการลงเวลาทำงาน",
  //       path: "/Form",
  //       key: "AbstainTimeCreate",
  //       component: AbstainTimeForm,
  //       isShow: true,
  //       children: [
  //         {
  //           path: "/edit/:postId",
  //           component: AbstainTimeForm,
  //         },
  //       ],
  //     },
  //     {
  //       label: "รายการอนุมัติขอแก้ไขการลงเวลาทำงาน",
  //       path: "/Confirm",
  //       key: "AbstainTimeConfirm",
  //       component: AbstainTimeDashboardApproves,
  //       isShow: true,
  //       children: [
  //         {
  //           path: "/:postId",
  //           component: AbstainTimeFormApproves,
  //         },
  //       ],
  //     },
  //   ],
  // },
  {
    key: "Fund",
    label: "กองทุนสำรองเลี้ยงชีพ",
    icon: "appstore",
    path: "/Fund",
    isShow: true,
    component: News,
    children: [
      {
        label: "ข้อมูลกองทุนสำรองเลี้ยงชีพ",
        icon: "",
        path: "/Detail",
        isShow: true,
        component: Fund,
      },
      {
        label: "ข่าวสารกองทุนสำรองเลี้ยงชีพ",
        icon: "",
        path: "/News",
        isShow: true,
        component: FundNews,
      },
      {
        path: "/detailnews/:newId",
        component: DetailNews,
      },
      {
        path: "/benefitsPerson",
        component: FundBenefitsPerson,
      },
      {
        path: "/benefitsPerson/:newId",
        component: FundBenefitsPerson,
      },
    ],
  },
  {
    key: "childEducationFee",
    label: "ค่าการศึกษาบุตร",
    icon: "appstore",
    path: "/childEducationFee",
    isShow: true,
    component: ChildEducationFee,
    children: [
      {
        key: "DetailChildEducationFee",
        icon: "",
        path: "/DetailChildEducationFee",
        isShow: false,
        children: [
          {
            path: "/:id",
            component: ChildEducationFeeDetail,
          },
        ],
      },
    ],
  },
  {
    key: "Leave",
    label: "การลา",
    icon: "appstore",
    path: "/Leave",
    isShow: true,
    children: [
      {
        label: "รายการขอลาทั้งหมด",
        path: "/search",
        component: LeaveSearchForm,
        isShow: true,
      },
      {
        label: "เพิ่มคำขอลา",
        path: "/day",
        key: "LeaveCreate",
        component: LeaveForm,
        isShow: true,
        children: [
          {
            path: "/edit/:postId",
            component: LeaveFormDetail,
          },
          {
            path: "/darf/:postId",
            component: LeaveFormDetailDarf,
          },
        ],
      },
      {
        label: "รายการอนุมัติการลา",
        path: "/Confirm",
        key: "LeaveConfirm",
        component: LeaveConfirm,
        isShow: true,
        children: [
          {
            path: "/noti/:postId",
            component: LeaveConfirmNotification,
          },
          {
            path: "/:postId/:status",
            component: LeaveConfirmDetail,
          },
        ],
      },
      {
        label: "รายการอนุมัติยกเลิกการลา",
        path: "/CancelConfirm",
        key: "LeaveCancel",
        component: LeaveCancel,
        isShow: true,
        children: [
          {
            path: "/:postId",
            component: LeaveCancelDetail,
          },
        ],
      },
      {
        label: "สรุปข้อมูลการลา",
        path: "/ListForManager",
        key: "ListForManager",
        component: ListForManager,
        isShow: true,
        children: [
          {
            path: "/noti/:postId",
            component: LeaveConfirmNotification,
          },
          {
            path: "/:postId/:status",
            component: LeaveConfirmDetail,
          },
        ],
      },
      {
        label: "คู่มือการใช้งาน",
        path: "/LeaveManual",
        key: "LeaveManual",
        component: LeaveManual,
        isShow: true,
      },
    ],
  },
  //    {
  // 		key: 'welfareList',
  // 		label: 'รายการเบิกเงินสวัสดิการ',
  // 		icon: 'appstore',
  // 		path: '/welfareList',
  // 		isShow: true,
  //       component: WelfareList,
  // 		children: [
  // 			// {
  // 			// 	label: 'รายการขอลาทั้งหมด',
  // 			// 	path: '/search',
  // 			// 	component: LeaveSearchForm,
  // 			// 	isShow: true,
  // 			// },
  // 			{
  // 				label: 'เพิ่มคำขอลา',
  // 				path: '/detail',
  // 				// component: LeaveForm,
  // 				// isShow: true,
  // 				children: [
  // 					{
  // 						path: '/paymentVictim/:postId',
  // 						component: WelfareListPaymentVictim
  // 					},
  // 					{
  // 						path: '/studyPayment/:postId',
  // 						component: WelfareListStudyPayment
  // 					},

  //                // {
  // 					// 	path: '/darf/:postId',
  // 					// 	component: LeaveFormDetailDarf
  // 					// },
  // 				]
  // 			},

  // 		]
  // 	},
  {
    key: "welfareList",
    label: "เบิกเงินสวัสดิการ",
    icon: "appstore",
    path: "/welfare",
    isShow: true,
    children: [
      {
        label: "รายการเบิกเงินสวัสดิการ",
        path: "/welfareList",
        component: WelfareList,
        isShow: true,
        children: [
          {
            label: "เพิ่มคำขอลา",
            path: "/form",
            children: [
              {
                path: "/paymentVictim/:postId",
                component: WelfareListPaymentVictim,
              },
              {
                path: "/studyPayment/:postId",
                component: WelfareListStudyPayment,
              },
              {
                path: "/otherWelfare/:postId",
                component: WelfareListOtherWelfare,
              },
            ],
          },
        ],
      },
      {
        label: "รายการอนุมัติเบิกสวัสดิการ",
        path: "/welfareApproveList",
        key: "WelfareConfirm",
        component: WelfareListDashboardApproves,
        isShow: true,
        children: [
          {
            label: "เพิ่มคำขอลา",
            path: "/form",
            children: [
              {
                path: "/paymentVictim/:postId",
                component: WelfareListPaymentVictim,
              },
              {
                path: "/studyPayment/:postId",
                component: WelfareListStudyPayment,
              },
              {
                path: "/otherWelfare/:postId",
                component: WelfareListOtherWelfare,
              },
            ],
          },
        ],
      },
    ],
  },

  {
    key: "Delegate",
    label: "มอบอำนาจการอนุมัติ",
    icon: "solution",
    path: "/Delegate",
    isShow: true,
    component: Delegate,
  },
  // {
  // 	key: 'workHistory',
  // 	label: 'ประวัติการทำงาน',
  // 	icon: 'file-text',
  // 	path: '/workHistory',
  // 	path: '/workHistory',
  // 	isShow: true,
  // 	component: workHistory,
  // },

  {
    key: "timeAttendance",
    label: "แสดงเวลาเข้า-ออก",
    icon: "calendar",
    path: "/timeAttendance",
    isShow: true,
    component: Attendace,
  },
  // {
  // 	key: 'slip',
  // 	label: 'สลิปเงินเดือน',
  // 	icon: 'file-pdf',
  // 	path: '/slip',
  // 	isShow: true,
  // 	component: Slip,
  // },
  {
    key: "slip",
    label: "เอกสารเกี่ยวกับเงินได้",
    icon: "file-pdf",
    path: "/slip",
    isShow: true,
    component: Slip,
  },
  {
    key: "policy",
    label: "ระเบียบ/หลักเกณฑ์",
    icon: "profile",
    isShow: true,
    path: "/policy",
    children: [
      {
        label: "โรงพยาบาลจุฬาลงกรณ์ สภากาชาดไทย",
        path: "/officerDocuments",
        isShowSubmenuDynamic: [1],
        component: PolicyOfficerDocuments,
      },
      {
        label: "เอกสารคุณภาพ",
        path: "/PolicyQualityDocument",
        isShowSubmenuDynamic: [1],
        component: PolicyQualityDocument,
      },
      {
        path: "/dashboard/:gropId",
        component: Policy,
      },
      {
        path: "/detail/:gropId",
        component: PolicyDetail,
      },
    ],
  },
  {
    key: "course",
    label: "หลักสูตร",
    icon: "file-text",
    path: "/course",
    isShow: true,
    component: Course,
    children: [
      // {
      // 	label: 'หลักสูตรการงาน',
      // 	path: '/WORK',
      // 	isShow: true,
      // 	component: Course
      // },
      {
        path: "/WORK/:courseId",
        component: CourseDetail,
      },
      {
        path: "/CONICLE/:courseId",
        component: CourseDetailConicle,
      },
    ],
  },
  {
    key: "orientation",
    label: "ปฐมนิเทศ",
    icon: "file-text",
    path: "/orientation",
    isShow: false,
    component: Orientation,
    children: [
      {
        // label: 'detail',
        path: "/:newId",
        component: OrientationDetail,
      },
    ],
  },
  {
    key: "abouts",
    label: "ข้อมูลลิงก์หน่วยงาน",
    icon: "bulb",
    isShow: true,
    path: "/abouts",
    component: AboutsLink,
    children: [
      // {
      // 	key: 'history',
      // 	label: 'ประวัติความเป็นมา',
      // 	path: '/history',
      // 	isShow: true,
      // 	component: Abouts
      // },
      // {
      // 	key: 'link',
      // 	label: 'ลิงก์หน่วยงาน',
      // 	path: '/link',
      // 	isShow: true,
      // 	component: AboutsLink,
      // 	children: [
      {
        // label: '/:postId',
        path: "/link/:postId",
        component: AboutsLinkDetail,
      },
      // 	]
      // },
    ],
  },
  {
    key: "contactHr",
    label: "ข้อมูล HR",
    icon: "solution",
    path: "/contactHR",
    isShow: false,
    children: [
      {
        key: "management",
        label: "สำนักงานบริหารทรัพยากรบุคคล",
        path: "/management",
        fetchKey: "31531c66-9eb0-4a1f-a2cd-b8b1a0f4c9ff",
        isShow: true,
        component: ContactHR,
      },
      {
        key: "strategyHR",
        label: "ยุทธศาสตร์ HR",
        path: "/strategyHR",
        fetchKey: "ea203def-e656-4fcc-a280-381fc91ee3d0",
        isShow: true,
        component: ContactHR,
      },
      {
        key: "regulations",
        label: "ความเป็นมา",
        path: "/regulations",
        fetchKey: "2de3a371-77e4-4578-af9e-6da00952c327",
        isShow: true,
        component: ContactHR,
      },
      // {
      // 	label: 'ข้อมูลติดต่อ',
      // 	path: '/contact',
      // 	isShow: true,
      // 	component: Contact,
      // },
    ],
  },
  {
    key: "profile",
    label: "ข้อมูลทั่วไป",
    icon: "user",
    path: "/profile",
    isShow: true,
    children: [
      {
        label: "ข้อมูลส่วนตัว",
        icon: "",
        path: "/list",
        isShow: true,
        component: ProFileList,
      },
      // {
      // 	label: 'สถานภาพส่วนตัว',
      // 	icon: '',
      // 	path: '/personalStatus',
      // 	isShow: true,
      // 	component: ProFilePersonalStatus,
      // },
      // {
      // 	label: 'ข้อมูลบุคลากร',
      // 	icon: '',
      // 	path: '/personalInformation',
      // 	isShow: true,
      // 	component: ProFilePersonalInformation,
      // },
      // {
      // 	label: 'ตั้งการแจ้งเตือน',
      // 	icon: '',
      // 	path: '/config',
      // 	isShow: true,
      // 	component: LayoutsNoData,
      // },
      {
        label: "เปลี่ยนรหัสผ่าน",
        icon: "",
        path: "/resetPassword",
        isShow: true,
        component: ChangePassword,
      },
      {
        label: "เบอร์โทรศัพท์ใหม่",
        icon: "",
        path: "/FormPhone",
        isShow: true,
        component: FormPhone,
      },
      {
        label: "ตั้งค่าความปลอดภัย",
        path: "/SecuritySettings",
        key: "SecuritySettings",
        isShow: true,
        component: SecuritySettings,
        isShowSubmenuDynamic: [0],
      },
      // {
      // 	label: 'บัญชีผู้ใช้',
      // 	icon: '',
      // 	path: '/account',
      // 	isShow: true,
      // 	component: LayoutsNoData,
      // }
    ],
  },
  {
    key: "employeeRegistration",
    label: "ทะเบียนประวัติบุคลากร",
    icon: "idcard",
    path: "/employeeRegistration",
    isShow: true,
    children: [
      {
        label: "ข้อมูลบุคลากร",
        icon: "",
        path: "/detail",
        isShow: true,
        component: ProFileDetail,
      },
      {
         key: "leaveStudies",
         label: "การศึกษา/ฝึกอบรมเฉพาะทาง",
         icon: "appstore",
         path: "/LeaveStudies",
         component: LeaveStudiesDashboard,
         isShow: true,
         children: [
         //   {
         //     label: "รายการการศึกษา/ฝึกอบรมเฉพาะทาง",
         //     path: "/Dashboard",
         //     component: LeaveStudiesDashboard,
         //     isShow: true,
         //   },
           {
             label: "เพิ่มคำขอลา",
             path: "/day",
             // component: LeaveForm,
             isShow: false,
             children: [
               {
                 path: "/edit/:postId",
                 component: LeaveStudiesForm,
               },
               // {
               // 	path: '/darf/:postId',
               // 	component: LeaveFormDetailDarf
               // },
             ],
           },
         ],
       },
      {
        key: "AlwaysUpcoming",
        label: "รายการประวัติการพัฒนาบุคลากร",
        icon: "appstore",
        path: "/AlwaysUpcoming",
        isShow: true,
        component: AlwaysUpcoming,
      },
      {
        key: "workHistory",
        label: "ประวัติการทำงาน",
        icon: "file-text",
        path: "/workHistory",
        isShow: true,
        component: workHistory,
      },
      {
        label: "ข้อมูลที่อยู่",
        icon: "",
        path: "/address",
        isShow: true,
        component: ProFileAddress,
      },
      {
        key: "rights",
        label: "สมาชิกในครอบครัว/สิทธิรักษาพยาบาล",
        icon: "",
        path: "/rights",
        isShow: true,
        component: EmpRegistrationRights,
      },
      {
        key: "payment",
        label: "ข้อมูลการเงิน",
        icon: "",
        path: "/payment",
        isShow: true,
        component: EmpRegistrationPayment,
      },
      {
        key: "tax",
        label: "ค่าลดหย่อนภาษี",
        icon: "",
        path: "/tax",
        isShow: true,
        component: EmpRegistrationTax,
      },
    ],
  },
  {
    key: "contact",
    label: "ข้อมูลติดต่อภายใน",
    icon: "phone",
    path: "/contact",
    isShow: true,
    component: Contact,
    children: [
      {
        path: "/department/:departmentId",
        component: ContactDepartment,
        children: [
          {
            path: "/:contactId",
            component: ContactDetail,
          },
        ],
      },
    ],
  },
  //   {
  //     key: "meeting",
  //     label: "ระบบจัดการประชุม",
  //     icon: "calendar",
  //     path: "/meetingmanagement",
  //     isShow: true,
  //     children: [
  //       {
  //         label: "ปฏิทินของฉัน",
  //         icon: "",
  //         path: "/meeting",
  //         isShow: true,
  //         component: MeetingManagement,
  //       },
  //       {
  //         label: "รายการประชุมที่ถูกเชิญ",
  //         icon: "",
  //         path: "/joinMeeting",
  //         isShow: false,
  //         component: CalendarForm,
  //       },
  //       {
  //         label: "สร้างการประชุม",
  //         icon: "",
  //         path: "/createMeeting",
  //         isShow: true,
  //         component: CreateMeeting,
  //       },
  //       {
  //         label: "สร้างการประชุม",
  //         icon: "",
  //         path: "/createMeetingForm",
  //         isShow: false,
  //         component: CreateMeetingForm,
  //       },
  //       {
  //         label: "สร้างการประชุม",
  //         icon: "",
  //         path: "/createMeetingFormWithApprove",
  //         isShow: false,
  //         component: CreateMeetingFormWithApprove,
  //       },
  //       {
  //         label: "รายละเอียดการประชุมที่เคยสร้าง",
  //         icon: "",
  //         path: "/viewMeetingForm",
  //         isShow: false,
  //         component: ViewMeetingForm,
  //       },
  //       {
  //         key: "รายการที่รอดำเนินการ",
  //         label: "รายการที่รอดำเนินการ",
  //         icon: "file-text",
  //         path: "/waitMeeting",
  //         isShow: true,
  //         component: WaitMeeting,
  //         children: [
  //           {
  //             label: "ส่งบันทึกหลังการประชุม",
  //             icon: "",
  //             path: "/sentNoteMeetingForm",
  //             isShow: false,
  //             component: SentNoteMeetingForm,
  //           },
  //         ],
  //       },
  //       {
  //         label: "รายละเอียดการขออนุมัติ",
  //         icon: "",
  //         path: "/waitMeetingForm",
  //         isShow: false,
  //         component: WaitMeetingForm,
  //       },
  //       {
  //         label: "แก้ไขการขออนุมัติ",
  //         icon: "",
  //         path: "/waitMeetingFormEdit",
  //         isShow: false,
  //         component: WaitMeetingFormEdit,
  //       },
  //       {
  //         label: "รายการขออนุมัติ",
  //         icon: "",
  //         path: "/waitApproveList",
  //         isShow: true,
  //         component: WaitApproveList,
  //       },
  //       {
  //         label: "รายการขออนุมัติ",
  //         icon: "",
  //         path: "/approveMeetingForm",
  //         isShow: false,
  //         component: ApproveMeetingForm,
  //       },
  //       {
  //         label: "รายการประชุมที่ถูกเชิญ",
  //         icon: "",
  //         path: "/inviteMeeting",
  //         isShow: true,
  //         component: InviteMeeting,
  //       },
  //       {
  //         label: "รายละเอียดการประชุม",
  //         icon: "",
  //         path: "/inviteMeetingForm",
  //         isShow: false,
  //         component: InviteMeetingForm,
  //       },
  //       {
  //         label: "รายการขอความเห็นชอบ",
  //         icon: "",
  //         path: "/noteMeeting",
  //         isShow: true,
  //         component: NoteMeeting,
  //       },
  //       {
  //         label: "รายการขอความเห็นชอบ",
  //         icon: "",
  //         path: "/noteMeetingForm",
  //         isShow: false,
  //         component: NoteMeetingForm,
  //       },
  //       {
  //         label: "สร้างหนังสือเชิญประชุม",
  //         icon: "",
  //         path: "/createPDFMeeting",
  //         isShow: false,
  //         component: CreatePDFMeeting,
  //       },
  //     ],
  //   },
  ];

const splitMatchPath = (path) => {
  const matchPaths = path.split("/").reduce((previousValue, currentValue) => {
    if (currentValue) {
      previousValue.push(`/${currentValue}`);
    }
    return previousValue;
  }, []);
  return matchPaths;
};

const pathsToRoutes = (rootRoute, paths) => {
  let routes = [];

  if (paths.length) {
    var matchRoute = rootRoute.find((route) => route.path === paths[0]);
    if (matchRoute) {
      routes.push(matchRoute);
      paths.shift();
      if (matchRoute.children) {
        routes = [...routes, ...pathsToRoutes(matchRoute.children, paths)];
      }
    }
  }
  return routes;
};

export const getRoutesByMatchPaths = (matchPath) => {
  const paths = splitMatchPath(matchPath);
  return pathsToRoutes(routes, paths);
};

const renderRoute = (route, basePath = "") => (
  <Route
    exact
    key={basePath + route.path}
    path={basePath + route.path}
    render={(props) => <route.component {...props} {...route.props} />}
  />
);

const mapRoutes = (routes, parentPath = "") => {
  let routeComponents = [];
  for (let route of routes) {
    if (route.children) {
      routeComponents = [
        ...routeComponents,
        ...mapRoutes(route.children, parentPath + route.path),
      ];
    }
    if (route.component) {
      routeComponents.push(renderRoute(route, parentPath));
    }
  }
  return routeComponents;
};

const renderDefaultRoute = () => <Route component={NotFound} />;

export const renderAllRoutes = () => (
  <Switch>
    {mapRoutes(routes)}
    {renderDefaultRoute()}
  </Switch>
);
